import { useEffect, useState } from 'react';

const MOBILE_WIDTH = 768;

const getWindowDimensions=()=> {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
    mobile: width < MOBILE_WIDTH,
  };
}

const useWindowSize= ()=>  {
  const [windowSize, setWindowSize] = useState(getWindowDimensions());

  const handleSize = () => {
    setWindowSize(getWindowDimensions());
  };

  useEffect(() => {
    window.addEventListener('resize', handleSize);
    return () => window.removeEventListener('resize', handleSize);
  }, []);


  return windowSize;
};

export default useWindowSize;